/**
 * Typed network-failure detection across the app's two HTTP stacks.
 * Replaces JSON.stringify substring matching (design §5.2 / spec §3.1).
 */
const AXIOS_NETWORK_CODES = new Set([
  'ERR_NETWORK',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ENOTFOUND',
  'ECONNREFUSED',
]);

export const isNetworkError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;
  const e = error as Record<string, any>;

  // RTK Query fetchBaseQuery typed statuses
  if (e.status === 'FETCH_ERROR' || e.status === 'TIMEOUT_ERROR') return true;

  // Axios error codes / request-made-no-response
  if (typeof e.code === 'string' && AXIOS_NETWORK_CODES.has(e.code)) return true;
  if (e.isAxiosError === true && e.request && !e.response) return true;

  // React Native fetch rejection
  if (
    e.name === 'TypeError' &&
    typeof e.message === 'string' &&
    e.message.toLowerCase().includes('network request failed')
  ) {
    return true;
  }

  return false;
};
